export interface ITrackingPackageInfo {
  id: number | string | undefined;
  cnt: number;
  name: string;
  price: number;
  discount: number;
}

export enum ETrackingSiteType {
  App = 'android/IOS',
  Desktop = 'desktop',
  Mobile = 'mobile',
}
